import { Ref, forwardRef, useState, useImperativeHandle } from 'react';
import { createPortal } from 'react-dom';
import { QRCodeImage } from './QRCodeImage';

interface LinkQRCodeProps {}

type Params = Array<{ href: string; region: Conversation.Conversation['region'] }>;

export interface LinkQRCodeRef {
  sendQRCode: (params: Params) => void;
}

const LinkQRCodeComponent = (props: LinkQRCodeProps, ref: Ref<LinkQRCodeRef>) => {
  const [value, setValue] = useState<
    Array<{ href: string; region: Conversation.Conversation['region'] }>
  >([]);
  const [activeIndex, setActiveIndex] = useState(0);

  useImperativeHandle(ref, () => ({
    sendQRCode: (params) => {
      setValue(params);
      setActiveIndex(0);
    },
  }));

  return (
    <>
      {value.map(({ href, region }, index) =>
        activeIndex === index
          ? createPortal(
              <QRCodeImage
                key={href}
                href={href}
                region={region}
                onSend={() => {
                  let index = 0;
                  setActiveIndex((prev) => {
                    index = prev + 1;
                    return index;
                  });
                  if (index === value.length - 1) {
                    requestAnimationFrame(() => {
                      setValue([]);
                    });
                  }
                }}
              />,
              document.body,
            )
          : null,
      )}
    </>
  );
};

export const LinkQRCode = forwardRef(LinkQRCodeComponent);
